import React from 'react';
import Icon from '../../muiComponents/Icon';

interface ContactDetailProps {
    iconName: string;
    text: React.ReactNode;
    truncate?: boolean;
}

const ContactDetail = ({
    iconName,
    text,
    truncate = true,
}: ContactDetailProps) => (
    <div className='contact-card__details'>
        <Icon iconName={iconName} className='text-primary-400' />
        <p
            className={`contact-card__details__text${
                truncate ? ' text-overflow-ellipsis' : ''
            }`}
        >
            {text}
        </p>
    </div>
);

export default ContactDetail;
